import { render, staticRenderFns } from "./ProgettoRiabilitativoIndividualeListPage.vue?vue&type=template&id=73cf7636"
import script from "./ProgettoRiabilitativoIndividualeListPage.vue?vue&type=script&lang=js"
export * from "./ProgettoRiabilitativoIndividualeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports